<template>
  <div>
    <span v-show="false">{{ gotResults }}</span>

    <section style="margin-right: 20px; margin-top: 10px">
      <div class="box box-danger">
        <div class="box-header">
          <h3 class="box-title">IP Range Requests</h3>
          <button class="btn btn-info pull-right" @click="toggleIpInput">
            Create New IP Range Request
          </button>
        </div>
        <div class="box-body" v-if="showIpInput">
          <div class="row mb-2">
            <div class="col-md-4">
              <input
                type="text"
                class="form-control"
                placeholder="Start IP"
                v-model="startIP"
              />
            </div>
            <div class="col-md-4">
              <input
                type="text"
                class="form-control"
                placeholder="End IP"
                v-model="endIP"
              />
            </div>
            <div class="col-md-4">
              <button class="btn btn-success" @click="addIpRange">Add</button>
            </div>
          </div>
          <div class="row mb-2" v-if="this.isAddIpError">
            <div class="col-md-8 text-danger">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              IP Format is not correct.
            </div>
          </div>
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">Requested IP Ranges</h3>
            </div>
            <div class="box-body">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Start IP</th>
                    <th>End IP</th>
                    <th>Type</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ip in requestedIpRanges" :key="ip.id">
                    <td>{{ ip.start }}</td>
                    <td>{{ ip.end }}</td>
                    <td>{{ ip.type }}</td>
                    <td>{{ ip.username }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="box box-danger">
        <div class="box-header">
          <h3 class="box-title">Approved IP Ranges</h3>
        </div>
        <div class="box-body">
          <div v-if="this.isError" class="text-danger">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            Error occurred while loading the data.
          </div>

          <app-no-data
            v-if="this.ipRangeData == null || this.ipRangeData.length == 0"
          ></app-no-data>
          <div v-show="this.ipRangeData != null && this.ipRangeData.length > 0">
            <table
              v-if="!this.isError"
              :id="tableId"
              class="table table-bordered table-striped"
            />
          </div>
        </div>
        <div v-if="this.isLoading" class="overlay">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    partyType: {
      type: String,
      required: false,
      default: "organization",
    },
  },
  data() {
    return {
      showIpInput: false,
      startIP: "",
      endIP: "",
      isAddIpError: false,
      requestedIpRanges: [],
      tableRef: null,
      tableId:
        "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1 + Date.now(),
      tableId2:
        "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 2 + Date.now(),
      tableColumns: [
        {
          data: "partyName",
          title: "Party Name",
          type: "string",
          render: this.partyRender,
          orderData: [1],
        },
        {
          data: "start",
          title: "Start Date",
          type: "string",
          visible: true,
        },
        {
          data: "end",
          title: "End Date",
          type: "string",
          visible: true,
        },
        {
          data: "createdAt",
          title: "Created At",
          type: "string",
          render: this.dateRender,
          visible: true,
        },
      ],
    };
  },
  mounted() {
    this.updateTableColumns();
    this.$store.dispatch("iprange/setRequests");
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("iprange", [
      "ipRangeData",
      "filter",
      "isError",
      "isLoading",
      "requests",
    ]),
    gotResults() {
      if (this.tableRef != null) this.tableRef.destroy();
      this.buildTable();
      return this.ipRangeData;
    },
  },
  watch: {
    requests: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.requestedIpRanges = newVal.filter((r) => r.type === "add");
        }
      },
    },
    filter: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.filter && this.filter.partyId) {
          this.requestedIpRanges = this.requests.filter(
            (r) => r.type === "add"
          );
          this.requestedIpRanges = this.requestedIpRanges.filter(
            (r) => r.partyId === this.filter.partyId
          );
        }
      },
    },
  },
  methods: {
    toggleIpInput() {
      this.showIpInput = !this.showIpInput;
    },
    isValidIPv4(ip) {
      const ipv4Pattern =
        /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})$/;
      return ipv4Pattern.test(ip);
    },
    addIpRange() {
      this.isAddIpError = false;
      if (this.isValidIPv4(this.startIP) && this.isValidIPv4(this.endIP)) {
        let payload = {
          start: this.startIP,
          end: this.endIP,
          type: "add",
          username: this.loggedInUser.username,
          partyId: this.filter.partyId,
        };
        // console.log(payload);
        this.$store
          .dispatch("iprange/addRequest", payload)
          .then((res) => {
            // console.log(res);
            if (res == true) {
              this.$store.dispatch("iprange/setRequests");
            }
          })
          .catch((err) => {
            console.log(err);
          });
        this.startIP = "";
        this.endIP = "";
      } else {
        this.isAddIpError = true;
      }
    },
    dateRender(data, type, row) {
      if (!data) return "";
      return moment(data).format("DD-MMM-YYYY");
    },
    updateTableColumns() {
      if (this.loggedInUser && this.loggedInUser.role == "Admin") {
        this.tableColumns.push({
          data: null,
          title: "Delete",
          render: function (data, type, row) {
            return (
              '<div><button data-row-id="' +
              data.id +
              '" data-toggle="modal" data-target="#modal-danger" class="btn btn-danger btn-xs">' +
              '  <i class="fa fa-trash"></i></button></div>'
            );
          },
          orderable: false,
        });
      } else {
        this.tableColumns.push({
          data: null,
          title: "Request Delete",
          render: (data, type, row) => {
            // console.log({ data });
            let ipRangeId = data.ipRangeId;
            if (this.requests && this.requests.length > 0) {
              let req = this.requests.find((r) => r.ipRangeId == ipRangeId);
              if (req) {
                return "<div>Requested</div>";
              }
            }
            return (
              '<div><button data-row-id="' +
              data.id +
              '" data-toggle="modal" data-target="#modal-danger" class="btn btn-danger btn-xs">' +
              '  <i class="fa fa-trash"></i></button></div>'
            );
          },
          orderable: false,
        });
      }
    },
    partyRender(data, type, row) {
      if (!data) return "";

      let col = "";
      col += '<div class="text-fuchsia">' + data + "</div>";
      return col;
    },
    handleDeleteClick(event, data) {
      // console.log(data, this.loggedInUser);
      if (this.loggedInUser && this.loggedInUser.role == "Librarian") {
        let payload = {
          start: data.start,
          end: data.end,
          type: "delete",
          username: this.loggedInUser.username,
          ipRangeId: data.ipRangeId,
          partyId: this.filter.partyId,
        };
        // console.log(payload);
        this.$store
          .dispatch("iprange/addRequest", payload)
          .then((res) => {
            // console.log(res);
            if (res == true) {
              this.$store.dispatch("iprange/setRequests");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    buildTable() {
      // console.log(this.ipRangeData);
      this.tableRef = $("#" + this.tableId).DataTable({
        deferRender: true,
        aaData: this.ipRangeData,
        aoColumns: this.tableColumns,
        paging: true,
        lengthChange: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        dom: '<"top"Bt><"bottom"<"row"<"col-md-6 ln1"il><"col-md-6 pull-right"p>>>',
        oLanguage: { sSearch: '<i class="fa fa-search text-primary"></i>' },
        buttons: [
          {
            extend: "excel",
            text: '<i class="fa fa-file-excel-o"></i> Excel',
            className: "btn btn-success btn-xs",
            exportOptions: {
              columns: [1, 3, 2, 4],
            },
          },
          {
            extend: "pdf",
            exportOptions: {
              columns: [1, 3, 2, 4],
            },
            text: '<i class="fa fa-file-pdf-o"></i> PDF',
            className: "btn bg-primary btn-xs",
          },
          {
            extend: "print",
            exportOptions: {
              columns: [1, 3, 2, 4],
            },
            text: '<i class="fa fa-print"></i> Print',
            className: "btn btn-warning btn-xs",
          },
          {
            extend: "copy",
            exportOptions: {
              columns: [1, 3, 2, 4],
            },
            text: '<i class="fa fa-copy"></i> Copy',
            className: "btn btn-danger btn-xs",
          },
        ],
        createdRow: (row, data, dataIndex) => {
          $("td:last-child button", row).on("click", (event) => {
            this.handleDeleteClick(event, data);
          });
        },
      });

      $("div.dataTables_filter input").css({
        display: "inline-block",
        border: "1px solid #3b8ab8",
        padding: "5px",
      });
      $("div.dataTables_filter input").attr("placeholder", "Quick search...");
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/paywall/iprange/IpRangeResult.vue